import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter {
    isIncludeSubCategoriesFlag: boolean | null;
}

type HandlerType = CustomHandler<Parameter>;

export const CENCustomCategoriesFilter: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductList/CategoriesFilter",
        isIncludeSubCategoriesFlag: props.parameter.isIncludeSubCategoriesFlag,
    });
};

export const chain = [CENCustomCategoriesFilter];

const cenCustomCategoriesFilter = createHandlerChainRunner(chain, "CENCustomCategoriesFilter");
export default cenCustomCategoriesFilter;
